import { render, staticRenderFns } from "./report-tab-layout.vue?vue&type=template&id=43a30890"
import script from "./report-tab-layout.vue?vue&type=script&lang=ts"
export * from "./report-tab-layout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports